import { differenceInCalendarDays } from 'date-fns'

import { CalculadoraDeParcelasBase } from '@/features/simulador/shared/domain/calculadora-de-parcelas'
import type { IParcela } from '@/features/simulador/shared/types/calculadora-parcela.types'

export class CalculadoraDeParcelasSacocVParcelado extends CalculadoraDeParcelasBase {
  override calcularValorDePontoMedioDasParcelas(
    parcelas: IParcela[],
    taxaJurosDiarioAntesPontoMedio: number,
    taxaJurosDiarioDepoisPontoMedio: number,
    dataDoPontoMedio: string,
    dataSaldoCondicaoPreco?: string,
  ) {
    const converteParaValorPontoMedio = (parcela: IParcela): number => {
      const dataParcela = ['posConclusao', 'intermediariasPosConclusao'].includes(parcela.tipo)
        ? dataSaldoCondicaoPreco
        : parcela.data
      const quantidadeDias = differenceInCalendarDays(new Date(dataDoPontoMedio), new Date(dataParcela!))
      const taxaDiaria = quantidadeDias > 0 ? taxaJurosDiarioAntesPontoMedio : taxaJurosDiarioDepoisPontoMedio
      const valorPontoMedio = (parcela.valorSemImpostoEComissao ?? 0) * (1 + taxaDiaria) ** quantidadeDias
      return valorPontoMedio
    }

    return parcelas.map((parcela) => ({
      ...parcela,
      valorPontoMedio: converteParaValorPontoMedio(parcela),
    }))
  }
}
